export default {
  SET_LOADING(state, status) {
    state.loading = status;
  },

  SET_REVIEWS_DATA(state, data) {
    state.data = data;
  },

  SET_REVIEWS(state, reviews) {
    state.data.results = reviews;
  },

  SET_REPLIED_REVIEW(state, { id, review }) {
    if (!state.data || !Array.isArray(state.data.results)) {
      return;
    }
    state.data.results = state.data.results.map(item => {
      if (item.id === id) {
        return { ...item, ...review };
      }
      return item;
    });
  },

  DELETE_REPLIED_REVIEW(state, { id, newReview }) {
    if (!state.data || !Array.isArray(state.data.results)) {
      return;
    }
    state.data.results = state.data.results.map(item => {
      if (item.id === id) {
        return {
          ...item,
          id: newReview && newReview.id ? newReview.id : item.id,
          reply_comment: "",
          reply_comment_being_sent: "",
          reply_update_time: null
        };
      }
      return item;
    });
  },

  UPDATE_REVIEW_IN_LIST(state, { id, patch }) {
    if (!state.data || !state.data.results) {
      return;
    }
    state.data.results = state.data.results.map(item =>
      item.id === id ? { ...item, ...patch } : item
    );
  },

  SET_SELECTED_ITEMS(state, data) {
    state.selectedItems = data;
  },

  SET_ALL_REVIEWS_TOTAL_COUNT(state, data) {
    state.allReviewsTotalCount = data;
  },

  SET_ALL_ITEMS_SELECTED(state, data) {
    state.allItemsSelected = data;
  },

  SET_IS_AI_REPLY_IN_PROGRESS(state, data) {
    state.isAiReplyInProgress = data;
  },
  SET_AI_LIMITS(state, data) {
    state.aiLimits = data;
  }
};
